// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import moment from "moment";
// import "lib-flexible/flexible";
import './utils/flexible.js'

import Mint from "mint-ui";
Vue.use(Mint); // 引入全部组件
import "mint-ui/lib/style.css";
import './utils/tailwindcss.css'

Vue.prototype.$axios = axios;
Vue.prototype.$eventBus = new Vue();
Vue.prototype.$moment = moment;
moment.locale("zh-cn"); //汉化

import wechat from "weixin-js-sdk";
Vue.prototype.$wechat = wechat;

Vue.config.productionTip = false;
let url = window.location.href
var parts = url.split('.com'); 
var domain = parts[0].split('.')[1]; // 提取"//"后的部分  
Vue.prototype.changeUrl = domain
console.log(domain,'在main.js里测试URL');
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js